<template>
  <div class="receiptList">
    <el-tabs v-model="activeName" type="card" @tab-click="tabsClickHandle">
      <el-tab-pane
        v-for="(item, index) in switchNav"
        :key="index"
        :label="`${item.name} ( ${item.number} )`"
        :name="item.key"
      ></el-tab-pane>
    </el-tabs>
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="1" ref="BLM-search">
        <el-form-item prop="plateNo" label="车牌号">
          <el-select
            v-model="searchData.plateNo"
            filterable
            remote
            reserve-keyword
            placeholder="请输入"
            clearable
            :remote-method="getCarNoList"
            :loading="oLoading.fuzzySearch"
          >
            <el-option
              v-for="item in carList"
              :key="item.id"
              :label="item.plateNo"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="carId" label="车辆ID">
          <el-input
            v-number:integer="18"
            v-model="searchData.carId"
            placeholder="请输入车辆ID"
            clearable
          />
        </el-form-item>

        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          v-model="searchData.brandSeriesModel"
          :showModel="true"
          :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
          >
        </CarBrandSeriesModel>

        <el-form-item prop="customerId" label="客户名称">
          <el-select
            v-model="searchData.customerId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入"
            clearable
            :remote-method="getCustomer"
            :loading="oLoading.fuzzySearch"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.customerName"
              :value="item.id"
            >
              <CustomerNameOptionItem :data="item" />
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="id" label="出入库ID">
          <el-input
            v-number:integer="18"
            v-model="searchData.id"
            placeholder="请输入出入库ID"
            clearable
          />
        </el-form-item>

        <el-form-item label="是否上传验车信息" prop="hasInspection">
          <el-select
            v-model="searchData.hasInspection"
            clearable
            placeholder="请选择是否上传验车信息"
          >
            <el-option value="" label="全部" />
            <el-option
              v-for="item in isWhetherList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
              clearable
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="times" label="创建时间">
          <el-date-picker
            v-model="searchData.times"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>

        <el-form-item
          prop="type"
          label="出入库类型"
          v-if="activeName === 'allNum'"
        >
          <el-select v-model="searchData.type">
            <el-option
              v-for="item in outInTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="sourceType" label="出入库来源">
          <el-select v-model="searchData.sourceType">
            <el-option
              v-for="item in sourceTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="deptIdList" label="所属部门">
          <DeptSelect v-model="searchData.deptIdList" filterable clearable multiple />
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              @click="searchHandle"
              type="primary"
              size="small"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="resetHandle('search')" size="small"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item>
            <export
              :exportTemplate="exportTemplate"
              filename="出入库管理.xlsx"
              :params="getSearchParamrs()"
            />
          </el-form-item>
        </template>
      </QS-search>
    </el-form>

    <!-- 新的组件 -->
    <QS-common-table
      :columns="headColumn"
      :data="dataList"
      :loading="oLoading.search"
      :pagination="paginationData"
      @change="paginationChange"
      class="mt16"
    />
  </div>
</template>
<script>
import CARDICT from '@/store/dict/carDict.js'
// eslint-disable-next-line import/no-cycle
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import {
  FuzzySearch,
  getStockLogSummary,
} from '@/api/domain/cars'
import { getOutInListSensitive } from '@/api/carManage'
import selectOption from '@/store/dict/selectOptionDict'
import { operateMaxShowLength } from '@/store/dict/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  components: {
    CustomerNameOptionItem,
  },
  data() {
    return {
      activeName: 'allNum',
      switchNav: [
        {
          name: '全部记录',
          key: 'allNum',
          number: 0,
          value: 0,
        },
        {
          name: '待出库',
          key: 'toOutStockNum',
          number: 0,
          value: 1,
        },
        {
          name: '待入库',
          key: 'toInStockNum',
          number: 0,
          value: 2,
        },
        {
          name: '已作废',
          key: 'voidedNum',
          number: 0,
          value: 3,
        },
      ],
      exportTemplate: 'CarOutInList',
      oLoading: {
        fuzzySearch: false,
        search: false,
      },
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      searchData: {
        id: '',
        carId: '',
        plateNo: '',
        times: [],
        customerId: '',
        type: '',
        hasInspection: '',
        deptIdList: [],
        modelId: '',
        sourceType: '', // 出入库来源
        brandSeriesModel: {},
      },
      customerList: [],
      carList: [],
      dataList: [],
      headColumn: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '出入库ID',
            width: 100,
          },
          render: ({ row }) => {
            if (this.judgePermission('vehicle_stock_detail')) {
              return (
                <a class="cursor-point">
                  <span onClick={() => this.goOutInDetails(row)}>{row.id}</span>
                </a>
              )
            }
            return <span>{row.id}</span>
          },
        },
        {
          name: 'carId',
          columnProps: {
            prop: 'carId',
            label: '车辆ID',
          },
          render: ({ row }) => {
            if (this.judgePermission('vehicle_list_detail')) {
              return (
                <a class="cursor-point">
                  <span onClick={() => this.gotoCarDetails(row)}>
                    {row.carId}
                  </span>
                </a>
              )
            }
            return (
              <span onClick={() => this.gotoCarDetails(row)}>{row.carId}</span>
            )
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            width: 160,
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户名称',
            width: 110,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '创建时间',
            width: 160,
          },
          type: 'date',
        },
        {
          name: 'type',
          columnProps: {
            prop: 'type',
            label: '出入库类型',
            width: 100,
          },
          getText: ({ row }) => CARDICT.OUT_INT_TYPE()[row.type],
        },
        {
          name: 'sourceTypeName',
          columnProps: {
            prop: 'sourceTypeName',
            label: '出入库来源',
            width: 100,
          },
        },
        {
          name: 'takeOverTime',
          columnProps: {
            prop: 'takeOverTime',
            label: '交接完成时间',
            width: 160,
          },
        },
        {
          name: 'hasInspection',
          columnProps: {
            prop: 'hasInspection',
            label: '是否上传验车信息',
            width: 160,
          },
          getText: ({ row }) => (row.hasInspection ? '是' : '否'),
          columnHeaderTooltip: '验车信息包含验车交接文件和车辆相关图片',
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '出入库状态',
            width: 100,
          },
          getText: ({ row }) => {
            if (row.state === 0) {
              if (row.type === 1) {
                return '待出库'
              } else if (row.type === 2) {
                return '待入库'
              } else {
                return '--'
              }
            } else {
              return selectOption.outInState[row.state]
            }
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
            width: 150,
          },
          showEllipsisTooltip: true,
          limitEllipsisLine: 1,
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const edit = [
              {
                name: 'operate1',
                label: '编辑',
                action: () => this.goEditOutIn(row),
              },
            ]
            const confirm = [
              {
                name: 'operate2',
                label: '提交确认',
                action: () => this.goEditOutIn(row),
              },
            ]
            // state:出入库状态 0-待处理 1-已完成 2-已作废
            // sourceType: 5-一键换车
            if (
              Number(row.state) === 1 &&
              Number(row.sourceType) !== 5 &&
              this.judgePermission('vehicle_stock_edit')
            ) {
              return edit
            }
            if (
              Number(row.state) === 0 &&
              Number(row.sourceType) !== 5 &&
              this.judgePermission('vehicle_stock_submit')
            ) {
              return confirm
            }
          },
        },
      ],
      CAR_MODEL_FILTER_SCENE,
    }
  },
  computed: {
    activeValue() {
      return this.switchNav.filter((item) => item.key === this.activeName)[0]
        .value
    },
    outInTypeList() {
      return this.dictParseList(CARDICT.OUT_INT_TYPE(), true)
    },
    // 出入库来源
    sourceTypeList() {
      return this.dictParseList(CARDICT.OUT_INT_SOURCE_TYPE(), true)
    },
    isWhetherList() {
      return this.dictParseList(selectOption.isWhetherList)
    },
  },
  mounted() {
    this.searchData.id = this.$route.query.id
    this.getOutInList()
    this.getStockLogSummary()
  },
  methods: {
    tabsClickHandle() {
      this.resetHandle('search')
      this.searchHandle()
      this.getStockLogSummary()
    },
    getStockLogSummary() {
      getStockLogSummary().then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          Object.keys(data).forEach((key) => {
            this.switchNav.forEach((item) => {
              if (item.key === key) {
                item.number = data[key]
              }
            })
          })
        } else {
          this.switchNav.forEach((item) => {
            item.number = 0
          })
        }
      })
    },
    // 获取请求参数
    getSearchParamrs() {
      let createTimeStart = ''
      let createTimeEnd = ''
      let hasInspection = ''
      if (this.searchData.times.length) {
        createTimeStart = this.searchData.times[0]
        createTimeEnd = this.searchData.times[1]
      }
      if (this.searchData.hasInspection !== '') {
        hasInspection = Boolean(this.searchData.hasInspection)
      }
      const { brandSeriesModel } = this.searchData
      const params = {
        ...this.searchData,
        createTimeStart,
        createTimeEnd,
        hasInspection,
        tabNo: this.activeValue,
        brandId: brandSeriesModel.brandId || null,
        seriesId: brandSeriesModel.seriesId || null,
        modelId: brandSeriesModel.modelId || null,
      }
      delete params.brandSeriesModel
      return params
    },

    // 获取列表
    async getOutInList() {
      this.oLoading.search = true
      try {
        const params = this.getSearchParamrs()
        const { code, data } = await getOutInListSensitive({
          ...params,
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
          tabNo: this.activeValue,
        })
        this.oLoading.search = false
        if (code === 1) {
          this.paginationData.total = data.totalNum
          this.dataList = data.items
        }
      } catch (error) {
        this.oLoading.search = false
      }
    },

    // 搜索事件
    searchHandle() {
      this.paginationData.pageNum = 1
      const para = {
        pagination: this.paginationData,
      }
      this.paginationChange(para)
    },

    async getCustomer(query) {
      if (query.length < 1) return
      // 开启远程搜索
      this.oLoading.fuzzySearch = true
      searchByCustomerNameSensitive({
        customerState: 1,
        mixedType: 'YES',
        customerName: query,
      }).then(({ code, data = [] }) => {
        if (code === 1) {
          this.customerList = data
        }
      }).finally(() => {
        this.oLoading.fuzzySearch = false
      })
    },

    // 模糊搜索获取车牌号
    async getCarNoList(query) {
      if (query.length >= 4) {
        // 开启远程搜索
        this.oLoading.fuzzySearch = true
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 1,
          })
          this.oLoading.fuzzySearch = false
          if (code === 1) {
            this.carList = data
          }
          // 关闭远程搜索
        } catch (error) {
          this.oLoading.fuzzySearch = false
        }
      }
    },

    // 重置搜索事件
    resetHandle(from) {
      this.formResetFields(from)
      this.$refs.carBrandSeriesModelRef.reset()
      this.searchData.brandSeriesModel = {}
      this.searchData.id = ''
      this.searchHandle()
    },

    // 出入库详情页面
    goOutInDetails(row) {
      const { id, carId, contractId: orderId, deptId } = row
      this.$router.push({
        path: '/vehicle/outInStorage/detail',
        query: {
          id,
          carId,
          orderId,
          deptId,
        },
      })
    },

    // 车辆详情
    gotoCarDetails(row) {
      const { plateNo, carId: id, deptId } = row
      this.$router.push({
        path: '/vehicle/vehicleManage/detail',
        query: {
          plateNo,
          id,
          deptId,
          source: 'detail',
        },
      })
    },

    // 编辑出入库记录
    goEditOutIn(row) {
      const { id: stockId, contractId: orderId, carId, deptId } = row
      this.$router.push({
        path: '/vehicle/outInStorage/edit',
        query: {
          stockId,
          orderId,
          carId,
          deptId,
        },
      })
    },

    // 清空表单预留接口
    formResetFields(formRef) {
      this.$refs[formRef].resetFields()
    },

    paginationChange(result) {
      const { pagination } = result
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getOutInList()
    },
  },
}
</script>
<style scoped lang="scss">
.search-box {
  overflow: hidden;
  .el-input {
    width: 240px;
  }
  .el-select {
    width: 240px;
  }
  .search-btns {
    padding-left: 150px;
  }
  background-color: #f7f8fa;
}
.pagination {
  height: 60px;
}
</style>
